// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2lmb4","addWidgetButton":"Header_addWidgetButton__2IJho","dashboardTabs":"Header_dashboardTabs__3Pbai","active":"Header_active__2Vp8G"};